<template>
  <nav class="landing-bar">
    <div class="inner-landing-bar">
      <div class="landing-bar-left">
        <a href="/" class="navbar-brand">
          <img
            class="nav-logo"
            src="../../img/eflexLogo.png"
            alt="EFLEX Logo"
          />
        </a>
        <div class="nav-bar-links"></div>
      </div>
      <div class="landing-bar-middle">
        <a
          class="nav-menu-link"
          id="dashboard"
          :href="'/dashboard' + currentRole"
          >Dashboard</a
        >
        <a
          class="nav-menu-link"
          v-if="currentUsername === 'admin@localhost.com'"
          id="admin"
          href="/admin"
          >Admin</a
        >

        <v-menu
          v-if="currentCountry === 'BG'"
          open-on-hover
          bottom
          offset-y
          eager
          content-class="landing-menu-trading landing-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="nav-menu-link" id="trading" v-bind="attrs" v-on="on">
              Trading<v-icon class="menu-icon" id="tradingIcon">{{
                icons.mdiChevronDown
              }}</v-icon>
            </div>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in tradeBG"
              :key="index"
              :href="item.link"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu
        v-if="currentCountry !== 'BG'"
          open-on-hover
          bottom
          offset-y
          eager
          content-class="landing-menu-trading landing-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="nav-menu-link" id="trading" v-bind="attrs" v-on="on">
              Trading<v-icon class="menu-icon" id="tradingIcon">{{
                icons.mdiChevronDown
              }}</v-icon>
            </div>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in tradeTR"
              :key="index"
              :href="item.link"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-menu
          open-on-hover
          bottom
          offset-y
          eager
          content-class="landing-menu-intelligence landing-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="nav-menu-link"
              id="intelligence"
              v-bind="attrs"
              v-on="on"
            >
              Intelligence<v-icon class="menu-icon" id="intelligenceIcon">{{
                icons.mdiChevronDown
              }}</v-icon>
            </div>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in intelligence"
              :key="index"
              :href="item.link"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
        <v-menu
          open-on-hover
          bottom
          offset-y
          eager
          content-class="landing-menu-portfolio landing-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="nav-menu-link" id="portfolio" v-bind="attrs" v-on="on">
              Portfolio Management<v-icon
                class="menu-icon"
                id="portfolioIcon"
                >{{ icons.mdiChevronDown }}</v-icon
              >
            </div>
          </template>

          <v-list id="portfolioMenu">
            <v-list-item
              v-for="(item, index) in portfolio"
              :key="index"
              :href="item.link"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu
          open-on-hover
          bottom
          offset-y
          eager
          content-class="landing-menu-help landing-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="nav-menu-link" v-bind="attrs" v-on="on" id="help">
              Help<v-icon class="menu-icon" id="helpIcon">{{
                icons.mdiChevronDown
              }}</v-icon>
            </div>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in help"
              :key="index"
              :href="item.link"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <div class="landing-bar-right">
        <div v-if="!currentUser">
          <!-- <router-link to="/login" class="login-button nav-bar-link">
                Login
              </router-link>
            
              <router-link to="/register" class="signin-button">
                Sign Up
              </router-link> -->

          <a class="dash-link" href="/login"> Log In </a>
          <a class="dash-link" href="/register"> Sign Up </a>
        </div>

        <div class="flex" v-if="currentUser">
          <!-- <router-link to="/profile" class="signin-button">
                {{ currentUser.username }}
              </router-link> -->
          <li
            v-if="showAdminBoard && getRoute.includes('profile')"
            class="nav-bar-item"
          >
            <a href="/dashboardAdmin" class="role">Admin Board</a>
          </li>
          <li
            v-if="showModeratorBoard && getRoute.includes('profile')"
            class="nav-bar-item"
          >
            <router-link to="/mod" class="role">Moderator Board</router-link>
          </li>
          <li
            v-if="showTsoBoard && getRoute.includes('profile')"
            class="nav-bar-item"
          >
            <router-link to="/dashboardTSO" class="role">TSO Board</router-link>
          </li>
          <li
            v-if="showDsoBoard && getRoute.includes('profile')"
            class="nav-bar-item"
          >
            <router-link to="/dashboardDSO" class="role">DSO Board</router-link>
          </li>
          <li
            v-if="showFSPBoard && getRoute.includes('profile')"
            class="nav-bar-item"
          >
            <router-link to="/dashboardFSP" class="role">FSP Board</router-link>
          </li>
          <li
            v-if="showUserBoard && getRoute.includes('profile')"
            class="nav-bar-item"
          >
            <router-link to="/user" class="role">User Board</router-link>
          </li>
          <a class="user-link" :href="'/profile' + currentRole">
            <img
              src="https://www.pngfind.com/pngs/m/610-6104451_image-placeholder-png-user-profile-placeholder-image-png.png"
              alt="profile"
              class="profile-img"
            />
            <div>
              <!-- <div class="username">{{ currentUser.username }}</div>
              <div class="role">{{ getRole }}</div> -->
              <a class="role2" href @click.prevent="logOut"> Log Out </a>
            </div>
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
//import LandingContent from "./components/Landing/LandingContent"
//import Web3 from "web3";
import { mdiChevronDown } from "@mdi/js";
export default {
  //components: { LandingContent },
  props: ["active"],
  name: "app",
  data() {
    return {

      icons: {
        mdiChevronDown,
      },

      tradeBG: [
        {
          name: "Offers",
          link: "/offers",
        },
      ],

      tradeTR: [
        {
          name: "Offers",
          link: "/offers",
        },
      ],

      trade: [
        {
          name: "Matching",
          link: "/matchingFSP",
        },
        {
          name: "Offers",
          link: "/offers",
        },
        {
          name: "Requests",
          link: "/requestsFSP",
        },
      ],

      portfolio: [
        {
          name: "Summary",
          link: "/summaryFSP",
        },
        {
          name: "Assets",
          link: "/assets",
        },
        {
          name: "Devices",
          link: "/devices",
        },
        {
          name: "Profile",
          link: "/profileFSP",
        },
      ],
      help: [
        {
          name: "Tutorial",
          link: "/tutorialFSP",
        },
        {
          name: "Support",
          link: "/supportFSP",
        },
      ],
      intelligence: [
        {
          name: "Pricing Intelligence",
          link: "/pricingintelligenceFSP",
        },
        {
          name: "Forecasting",
          link: "/forecasting",
        },
      ],
    };
  },

  computed: {

    currentCountry() {
      return this.$store.state.auth.user.countryCode
    },

    currentUsername() {
      return this.$store.state.auth.user.username
    },
    
    currentRole() {
      switch (this.$store.state.auth.user.roles[0].name) {
        case "ROLE_ADMIN":
          return "Admin";

          break;

        case "ROLE_TSO":
          return "TSO";

          break;
        case "ROLE_DSO":
          return "DSO";

          break;
        case "ROLE_FSP":
          return "FSP";

          break;
        default:
         return "DSO";
      }
    },
    getRoute() {
      return this.$route.fullPath;
    },
    getRole() {
      return this.$store.state.auth.user.role.substring(5);
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_ADMIN");
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_MODERATOR");
      }

      return false;
    },
    showUserBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_USER");
      }

      return false;
    },

    showTsoBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_TSO");
      }

      return false;
    },
    showDsoBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_DSO");
      }

      return false;
    },
    showFSPBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes("ROLE_FSP");
      }

      return false;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/");
    },
    setHover(id) {
      document.getElementById(id).classList.add("menu-link-active");
    },
  },
  mounted() {
    document.getElementById(this.active).classList.add("nav-link-active");
    document
      .getElementById(this.active + "Icon")
      .classList.add("nav-link-active");

    document
      .querySelector(".landing-menu-portfolio")
      .addEventListener("mouseover", function () {
        document.getElementById("portfolio").classList.add("nav-hover");
        document.getElementById("portfolioIcon").classList.add("nav-hover");
      });
    document
      .querySelector(".landing-menu-portfolio")
      .addEventListener("mouseleave", function () {
        document.getElementById("portfolio").classList.remove("nav-hover");
        document.getElementById("portfolioIcon").classList.remove("nav-hover");
      });

    document
      .querySelector(".landing-menu-trading")
      .addEventListener("mouseover", function () {
        document.getElementById("trading").classList.add("nav-hover");
        document.getElementById("tradingIcon").classList.add("nav-hover");
      });
    document
      .querySelector(".landing-menu-trading")
      .addEventListener("mouseleave", function () {
        document.getElementById("trading").classList.remove("nav-hover");
        document.getElementById("tradingIcon").classList.remove("nav-hover");
      });

    document
      .querySelector(".landing-menu-intelligence")
      .addEventListener("mouseover", function () {
        document.getElementById("intelligence").classList.add("nav-hover");
        document.getElementById("intelligenceIcon").classList.add("nav-hover");
      });
    document
      .querySelector(".landing-menu-intelligence")
      .addEventListener("mouseleave", function () {
        document.getElementById("intelligence").classList.remove("nav-hover");
        document
          .getElementById("intelligenceIcon")
          .classList.remove("nav-hover");
      });

    document
      .querySelector(".landing-menu-help")
      .addEventListener("mouseover", function () {
        document.getElementById("help").classList.add("nav-hover");
        document.getElementById("helpIcon").classList.add("nav-hover");
      });
    document
      .querySelector(".landing-menu-help")
      .addEventListener("mouseleave", function () {
        document.getElementById("help").classList.remove("nav-hover");
        document.getElementById("helpIcon").classList.remove("nav-hover");
      });
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

.landing-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  width: 100%;
  background: #253858;
}

.inner-landing-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  width: 100%;
}

.dashboard-type {
  color: #fff;
}

.navbar-brand {
  display: flex;
  align-items: center;
}

.landing-bar-left {
  display: flex;
  align-items: center;
}

.nav-bar-links {
  display: flex;
  align-items: center;
}

.nav-bar-item {
  list-style: none;
}

.nav-logo {
  width: 150px;
  margin-right: 10px;
}

.nav-bar-link,
.nav-bar-link-active {
  color: $black;
  font-size: 1em;
  font-weight: 700;
  margin-left: 50px;
  padding: 10px 0;
  letter-spacing: 1.2px;
  position: relative;
  text-decoration: none;
}

.nav-bar-link:before,
.nav-bar-link-active:before {
  width: 0;
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  bottom: 3px;
  height: 2px;
  background: $green;
  -webkit-transition: 0.15s linear;
  transition: 0.15s linear;
}

.nav-bar-link:hover {
  color: $black;
  text-decoration: none;
}

.nav-bar-link:hover:before,
.nav-bar-link-active:before {
  width: 100%;
}

.login-button {
  color: $black;
  margin: 0 20px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.signin-button {
  color: #fff;
  background: $green2;
  padding: 10px 20px;
  border-radius: 20px;
  margin: 0 20px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.signin-button:hover {
  color: #fff;
  text-decoration: none;
  background: hsl(144, 58%, 40%);
}

.user-link {
  display: flex;
  align-items: center;
}

.profile-img {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  margin: 0 10px;
}

.username {
  padding: 5px 0;
  color: #fff;
  font-size: 12px;
}

.flex {
  display: flex;
  align-items: center;
}

.role {
  color: #fff !important;
  font-size: 12px;
  font-weight: 700;
}

.role2 {
  color: #fff !important;
  font-size: 12px;
}

.dash-link {
  color: #fff;
  font-size: 14px;
  margin-right: 10px;
}
.landing-bar-middle {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.nav-menu-link {
  color: #fff !important;
  font-size: 0.9em;
  padding: 10px 0;
  letter-spacing: 1.2px;
  font-weight: 700;
  margin-right: 50px;
}

.landing-bar-middle
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #f5f8fd !important;
}
.landing-menu .theme--light.v-list {
  background-color: #2f4160 !important;
}

.landing-menu
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #fff;
}

.menu-icon {
  color: #fff !important;
}

.landing-menu .theme--light.v-list-item:hover,
.nav-hover,
.nav-menu-link:hover,
.nav-menu-link:hover > .menu-icon,
.nav-link-active {
  color: #58c26d !important;
}

.landing-menu .v-list-item--link:before {
  background-color: #2f4160 !important;
}

// #portfolioMenu:hover ~ #portfolio {
//   color: #58c26d !important;
// }

// #portfolioMenu {
//   cursor: pointer;
// }
</style>